import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  referralSentContainer: {
    background: '#F5F5F5',
    color: '#4a4a4a',
    fontSize: 16,
    letterSpacing: '-0.5px',
    height: '100%',
    padding: '34px 35px',
    '@media(max-width: 1200px)': {
      paddingLeft: 30,
      margin: '0 auto'
    },
    '@media(max-width: 480px)': {
      padding: 20,
      width: '100%'
    }
  },
  referralSentCopy: {
    width: 870,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '125px 75px',
    background: '#FFF',
    textAlign: 'center',
    marginBottom: 20,
    '@media(max-width: 1200px)': {
      width: 'auto',
    },
    '@media(max-width: 480px)': {
      padding: '15% 20%',
    }
  },
  referralHeading: {
    marginBottom: 20
  },
  referralSentButtons: {
    marginBottom: 25,
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse'
    }
  },
  button: {
    marginRight: 30,
    width: 200,
    '&:last-child': {
      marginRight: 0
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 10,
      marginRight: 0,
      width: '100%'
    }
  },
  redirectButton: {
    width: 220
  },
  mailIcon: {
    marginTop: 45,
    height: '173px',
    width: '173px',
    margin: '0 auto'
  },
  coverForm: {
    position: "absolute",
    top: 160,
    left: 110,
    zIndex: 10,
    height: 540
  },
  link: {
    color: "#2d91e9",
    textDecoration: "none",
    fontFamily: "CircularStd",
    fontSize: 16,
  }
});
